import { gql } from '@apollo/client'

export const GetVideoProgresses = gql`
    query GetVideoProgresses {
        getVideoProgresses {
            messages
            errorMessages
            result {
                id
                uploadId
                uploadStatus
                jobConvertStatus
                jobConvertId
                createdOn
                createdBy
                modifiedBy
                modifiedOn
                videoId 
                video {
                    id
                    name
                    modifiedBy
                    isAvailable
                    modifiedOn
                    sequence
                    createdBy
                    createdOn
                    description
                    videoDuration
                    videoType
                    videoURL
                }
            }
            isError
        }
    }
`

export const GetPointSettings = gql`
    query GetAppSettings {
        getAppSettings {
            messages
            errorMessages
            isError
            result {
                trophyPointSettings {
                    id
                    name
                    value
                }
                userPointSettings {
                    id
                    name
                    value
                }
            }
        }
    }
`

export const GetVideoMaterials = gql`
    query GetVideoMaterials ($isGetAll: Boolean!, $filter: FilterInputType, $skip: Int, $take: Int, $sortBy: SortInputType) {
        getVideoMaterials(input: {
            filter: $filter 
            skip: $skip,
            isGetAll: $isGetAll,
            take: $take,
            sortBy: $sortBy
        }){
            messages
            errorMessages
            result {
                id
                name
                modifiedBy
                modifiedOn
                sequence
                createdBy
                isAvailable
                createdOn
                description
                videoURL,
                videoType,
                videoDuration
            }
            isError
        }
    }
`

export const GetDashboardInfo = gql`
    query GetDashboardInfo {
        getDashboardInfo {
            messages
            errorMessages
            result {
            totalActiveLearners
            totalActiveMonthlyUsers
            totalActivePremiumUsers
            totalActiveUsers
            totalActiveYearlyUsers 
            maxNumberAdditionalSlotEverSubscribed
            totalActiveAdditionalSlotUsers      
            }
            isError
        }
    }
`